import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">
              影视资讯
            </h2>
            <p className="text-foreground-500 text-xs mt-1">最新电影动态、影评与观影指南</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
        <div className="text-center mt-8">
          <Link
            to="/article/1"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-background-300 text-foreground-600 text-xs font-medium hover:border-primary-500 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            查看更多资讯 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}